import { isFalsy } from '../../../utils/common';
export var isFalsyOrZero = function (value) {
    return (String(value) === '0' ||
        value === '' ||
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && Object.keys(value).length === 0));
};
var validate = function (value) { return !isFalsyOrZero(value); };
export var validateIfCourseOverviewDetailsAreAvailable = function (courseOverview, courseUrl, universityUsps, conversionUsps) {
    var courseOverviewDetails = [courseOverview, courseUrl, universityUsps, conversionUsps];
    return courseOverviewDetails === null || courseOverviewDetails === void 0 ? void 0 : courseOverviewDetails.some(validate);
};
export var validateIfAcademicRequirementsDataIsAvailable = function (ugScore, twelfthScore) {
    var academicDetails = [
        twelfthScore === null || twelfthScore === void 0 ? void 0 : twelfthScore.score,
        ugScore === null || ugScore === void 0 ? void 0 : ugScore.score,
        ugScore === null || ugScore === void 0 ? void 0 : ugScore.fifteenYearsOfEducationAllowed,
        ugScore === null || ugScore === void 0 ? void 0 : ugScore.noOfBacklogsAccepted
    ];
    return academicDetails === null || academicDetails === void 0 ? void 0 : academicDetails.some(validate);
};
export var validateIfAdditionalExamRequirementsDataIsAvailable = function (courseDetails) {
    var _a, _b, _c, _d, _e, _f;
    var additionalExamData = [];
    (_b = ((_a = courseDetails === null || courseDetails === void 0 ? void 0 : courseDetails.additionalExams) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.forEach(function (data) {
        if (!data)
            return;
        additionalExamData === null || additionalExamData === void 0 ? void 0 : additionalExamData.push(data === null || data === void 0 ? void 0 : data.overAllScore);
        additionalExamData === null || additionalExamData === void 0 ? void 0 : additionalExamData.push(data === null || data === void 0 ? void 0 : data.quantitativeScore);
        additionalExamData === null || additionalExamData === void 0 ? void 0 : additionalExamData.push(data === null || data === void 0 ? void 0 : data.verbalScore);
    });
    var isMainEntryRequirementPresent = !isFalsy(courseDetails === null || courseDetails === void 0 ? void 0 : courseDetails.mainEntryRequirement) &&
        (!isFalsy((_d = (_c = courseDetails === null || courseDetails === void 0 ? void 0 : courseDetails.mainEntryRequirement) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.gapYear) ||
            !isFalsy((_f = (_e = courseDetails === null || courseDetails === void 0 ? void 0 : courseDetails.mainEntryRequirement) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.workExperienceRequired));
    return (additionalExamData === null || additionalExamData === void 0 ? void 0 : additionalExamData.some(validate)) || isMainEntryRequirementPresent;
};
export var validateIfEnglishExamRequirementsDataIsAvailable = function (englishExamDetails) {
    var _a;
    var englishExamData = [];
    (_a = (englishExamDetails !== null && englishExamDetails !== void 0 ? englishExamDetails : [])) === null || _a === void 0 ? void 0 : _a.forEach(function (data) {
        if (!data)
            return;
        englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.push(data === null || data === void 0 ? void 0 : data.overAllScore);
        englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.push(data === null || data === void 0 ? void 0 : data.readingScore);
        englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.push(data === null || data === void 0 ? void 0 : data.writingScore);
        englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.push(data === null || data === void 0 ? void 0 : data.listeningScore);
        englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.push(data === null || data === void 0 ? void 0 : data.speakingScore);
        if ((data === null || data === void 0 ? void 0 : data.examRequiredValue) === 'NOT_ACCEPTED') {
            englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.push(data === null || data === void 0 ? void 0 : data.examRequiredValue);
        }
    });
    return englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.some(validate);
};
export var filterIntakesInFutureWithDeadlineAndNotClosed = function (courseDetails) {
    var _a, _b;
    if (!courseDetails)
        return [];
    var intakesNotClosedWithDeadline = (_a = courseDetails === null || courseDetails === void 0 ? void 0 : courseDetails.intakes) === null || _a === void 0 ? void 0 : _a.filter(function (intake) {
        return (intake === null || intake === void 0 ? void 0 : intake.status) !== 'CLOSED' && (intake === null || intake === void 0 ? void 0 : intake.deadline);
    });
    var monthMap = {
        JAN: 0,
        FEB: 1,
        MAR: 2,
        APR: 3,
        MAY: 4,
        JUN: 5,
        JUL: 6,
        AUG: 7,
        SEP: 8,
        OCT: 9,
        NOV: 10,
        DEC: 11
    };
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth();
    var futureIntakes = (_b = intakesNotClosedWithDeadline === null || intakesNotClosedWithDeadline === void 0 ? void 0 : intakesNotClosedWithDeadline.filter(function (intake) {
        if (!(intake === null || intake === void 0 ? void 0 : intake.month) || !(intake === null || intake === void 0 ? void 0 : intake.year))
            return null;
        var monthOfIntake = monthMap[intake === null || intake === void 0 ? void 0 : intake.month];
        var isFuture = intake.year > currentYear || (intake.year === currentYear && monthOfIntake > currentMonth + 1);
        return isFuture;
    })) === null || _b === void 0 ? void 0 : _b.filter(function (intake) { return !!intake; });
    return futureIntakes;
};
export var validateIfApplicationFilingRequirementDataIsAvailable = function (courseDetails) {
    if (!courseDetails)
        return false;
    var futureIntakesWithDeadlineAndNotClosed = filterIntakesInFutureWithDeadlineAndNotClosed(courseDetails);
    var displayApplicationFilingSection = !isFalsy(courseDetails === null || courseDetails === void 0 ? void 0 : courseDetails.intakeMonths) ||
        !isFalsy(courseDetails === null || courseDetails === void 0 ? void 0 : courseDetails.applicationFee) ||
        !isFalsy(futureIntakesWithDeadlineAndNotClosed);
    return displayApplicationFilingSection;
};
//# sourceMappingURL=constants.js.map